var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"cursus-steps"},[_vm._l((_vm.visibleSteps),function(step,i){return [_c('Step',{attrs:{"step":step,"done":_vm.isDone(step),"active":_vm.isActive(step),"index":i + 1}})]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }